<template>
  <div class="mark-box">
    <div class="mark-box-header">
      <div class="header-left">
        <span>您当前所在位置 >  </span>
        <el-breadcrumb separator=">" style="margin-left: 4px" >
          <el-breadcrumb-item>评价管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{type === 1 ? '已批改' : '批改'}}</el-breadcrumb-item>
          <el-breadcrumb-item>理论题</el-breadcrumb-item>
          <el-breadcrumb-item>{{type === 1 ? '重新批改' : '批改'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <correctTheoryPaper :logId="logId" :headData="headData" :answerData="answerData" />
  </div>
</template>

<script>

import correctTheoryPaper from '@/components/correctTheoryPaper.vue'
import {markStartMarkJudge, markStartMarkTeacher} from "@/utils/apis";
export default {
  name: "MarkTheoryPaper",
  components:{
    correctTheoryPaper
  },
  data(){
    return {
      type:Number(this.$route.query.type)|| '', // 已批改 待批改 未提交
      logId:this.$route.query.logId || '', //	学生的答题记录ID
      headData:{},
      answerData:{},
      role:Number(localStorage.getItem('role'))|| '',
    }
  },
  mounted() {
    // 分辨评委端 教师端
    if(this.role === 4){
      this.getMarkStartMarkJudge()
    } else {
      this.getMarkStartMarkTeacher();
    }
  },
  methods:{
    // 获取评委页面批改数据
    getMarkStartMarkJudge(){
      let params = {
        student_theory_exam_log_id:this.logId
      }
      markStartMarkJudge(params).then((res)=>{
        this.headData = res.data.head_data;
        this.answerData = res.data.answer_data.list;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    // 获取教师端页面批改数据
    getMarkStartMarkTeacher(){
      let params = {
        student_theory_exam_log_id:this.logId
      }
      markStartMarkTeacher(params).then((res)=>{
        this.headData = res.data.head_data;
        this.answerData = res.data.answer_data.list;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    goBack(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-breadcrumb{
  .el-breadcrumb__inner{
    color: #2C95FF;
  }
  .el-breadcrumb__separator{
    color: #333333;
    font-weight: 500;
  }
}
.mark-box{
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  .mark-box-header{
    padding: 0px 0 30px;
    display: flex;
    border-bottom: 2px solid #F1F5FF;
    .header-left{
      display: flex;
      align-items: center;
      span{
        line-height: 1;
      }
    }
  }
}
</style>